import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {FinService} from "../models/FinService/fin-service";
import {filter} from "rxjs/operators";
import {from} from "rxjs";

@Injectable({
    providedIn: "root"
})
export class FinServiceHttpClientService {
    private readonly base = environment.backendBaseUrl;
    private readonly endpoint = "/api/services";
    private readonly fullPath = `${this.base}${this.endpoint}`;

    constructor(private http: HttpClient) {
    }

    async getFinServices() {
        const finServices = await this.http
            .get<FinService[]>(this.fullPath)
            .toPromise();

        // * Add "Te gjitha" option to list
        finServices.unshift({
            id: 0,
            isVisible: true,
            code: "Te Gjitha",
            title: "Te gjitha",
            iconPath: "",
            description: ""
        } as FinService);

        // * Filter which to show
        return finServices.filter((value) => {
            return value.isVisible;
        });
    }
}
